/**
 * Convert an enum to a union-type array
 * - Useful for converting TS enums to Schema enums
 * @param {Enum} obj
 */
export function typeEnum<V extends string>(obj: Record<string, V>): Array<V> {
    return Object.values(obj);
}

/**
 * Convert a string to a string literal type
 * - Useful for converting strings to Schema const values
 * @param {String} str
 */
export function typeConst<T extends string>(str: T): T {
    return str;
}

/**
 * Shorthand
 */

//  Value not applicable
export const NA = 'N/A';

//  Description not applicable
export const NO_DESC = { description: 'N/A' };
